// Currency formatting with native symbols + per-currency decimals.
// Mirrors /app/backend/currency_utils.py so backend & frontend stay in sync.

export const CURRENCY_DECIMALS = {
  USD: 2, EUR: 2, GBP: 2, EGP: 2, SAR: 2, AED: 2,
  KWD: 3, BHD: 3, OMR: 3, JOD: 3,
  JPY: 0,
};

export const CURRENCY_SYMBOLS = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  EGP: "£E ",
  SAR: "﷼ ",
  AED: "د.إ ",
  KWD: "د.ك ",
  BHD: "د.ب ",
  OMR: "ر.ع ",
  JOD: "د.أ ",
  JPY: "¥",
};

export function currencyDecimals(currency = "USD") {
  return CURRENCY_DECIMALS[(currency || "USD").toUpperCase()] ?? 2;
}

/**
 * Format an amount with the currency's native symbol + correct decimal count.
 * @param {number|string} amount
 * @param {string} currency  ISO 4217 code (default USD)
 * @returns {string} e.g. "$199.00", "د.ك 199.000", "﷼ 199.00"
 */
export function formatCurrency(amount, currency = "USD") {
  const cur = (currency || "USD").toUpperCase();
  const decimals = currencyDecimals(cur);
  const symbol = CURRENCY_SYMBOLS[cur] ?? `${cur} `;
  const n = Number(amount || 0);
  const isNegative = n < 0;
  const locale = typeof document !== "undefined" && document.documentElement.getAttribute("lang") === "ar" ? "ar-OM-u-nu-latn" : "en-US";
  const val = Math.abs(n).toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  // Explicit "-" prefix so RTL currency symbols (e.g. ر.ع) don't push the sign to the right,
  // which reads like a typo. Parentheses would be more accountant-friendly but break sort/copy.
  return `${isNegative ? "-" : ""}${symbol}${val}`;
}
